function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.99999 10C10.4602 10 10.8333 9.62694 10.8333 9.16671C10.8333 8.70647 10.4602 8.33337 9.99999 8.33337C9.53975 8.33337 9.16666 8.70647 9.16666 9.16671C9.16666 9.62694 9.53975 10 9.99999 10Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3333 10C13.7936 10 14.1667 9.62694 14.1667 9.16671C14.1667 8.70647 13.7936 8.33337 13.3333 8.33337C12.8731 8.33337 12.5 8.70647 12.5 9.16671C12.5 9.62694 12.8731 10 13.3333 10Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.66665 10C7.12688 10 7.49998 9.62694 7.49998 9.16671C7.49998 8.70647 7.12688 8.33337 6.66665 8.33337C6.20641 8.33337 5.83331 8.70647 5.83331 9.16671C5.83331 9.62694 6.20641 10 6.66665 10Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8333 2.5H4.16666C3.50362 2.5 2.86773 2.76339 2.39889 3.23223C1.93005 3.70107 1.66666 4.33696 1.66666 5V17.5C1.66691 17.6477 1.7064 17.7926 1.78107 17.92C1.85575 18.0474 1.96293 18.1526 2.09166 18.225C2.2162 18.2956 2.35683 18.3329 2.49999 18.3333C2.64956 18.3333 2.79636 18.293 2.92499 18.2167L6.66666 15.95C6.80496 15.8677 6.96415 15.8271 7.12499 15.8333H15.8333C16.4964 15.8333 17.1322 15.5699 17.6011 15.1011C18.0699 14.6323 18.3333 13.9964 18.3333 13.3333V5C18.3333 4.33696 18.0699 3.70107 17.6011 3.23223C17.1322 2.76339 16.4964 2.5 15.8333 2.5ZM16.6667 13.3333C16.6667 13.5543 16.5789 13.7663 16.4226 13.9226C16.2663 14.0789 16.0543 14.1667 15.8333 14.1667H7.12499C6.66984 14.1663 6.22323 14.2902 5.83332 14.525L3.33332 16.025V5C3.33332 4.77899 3.42112 4.56702 3.5774 4.41074C3.73368 4.25446 3.94564 4.16667 4.16666 4.16667H15.8333C16.0543 4.16667 16.2663 4.25446 16.4226 4.41074C16.5789 4.56702 16.6667 4.77899 16.6667 5V13.3333Z",
  fill: "black"
});

var SvgReview = function SvgReview(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReview, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/review.9783fc32.svg";
export { ForwardRef as ReactComponent };